
$(document).on('click', '[data-href]', function() {
    let $form = $("<form/>", {method: 'GET', action: $(this).data('href'), target: '_blank'});
    $form.on('submit', function() {
        setTimeout(function() {
            $form.remove();
        })
    });
    $('body').append($form);
    console.log($form.html());
    $form.submit();
});
